import React, { createContext, useReducer } from "react";
import { SearchAPI } from '../Services/Services';
import config from '../../config.json';

let initialState = {
  term: '',
  total: 0,
  active: 1,
  results: {},
  response: {},
  searching: false,
  query: config.query
};

const actions = {
  SET_TERM: "SET_TERM",
  SET_RESULTS: "SET_RESULTS",
  SET_RESPONSE: "SET_RESPONSE",
  SET_TOTAL: "SET_TOTAL",
  SET_ACTIVE: "SET_ACTIVE",
  SET_QUERY: "SET_QUERY",
  SET_SEARCHING: "SET_SEARCHING",
  SEARCH: "SEARCH",
  RESET: "RESET"
};

function reducer(state, action) {
  switch (action.type) {
    case actions.SET_TERM:
      return { ...state, term: action.value };
    case actions.SET_RESULTS:
      return { ...state, results: action.value };
    case actions.SET_RESPONSE:
        return { ...state, response: action.value };    
    case actions.SET_TOTAL:
      return { ...state, total: action.value };
    case actions.SET_ACTIVE:
      return { ...state, active: action.value };
    case action.SET_QUERY:
      return { ...state, query: action.value };
    case actions.SET_SEARCHING:
      return { ...state, searching: action.value };      
    case actions.RESET:
      return { ...state, ...initialState };
    default:
      return state;
  }
}

const SearchContext = createContext();

const Provider = ({children}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = {
    term: state.term,
    total: state.total,
    active: state.active,
    results: state.results,
    response: state.response,
    searching: state.searching,
    query: state.query,
    setTerm: value => {
      dispatch({ type: actions.SET_TERM, value });
    },
    setResults: value => {
      dispatch({ type:actions.SET_RESULTS, value });
    },
    setResponse: value => {
      dispatch({ type:actions.SET_RESPONSE, value });
    },
    setTotal: value => {
      dispatch({ type:actions.SET_TOTAL, value });
    },
    setActive: value => {
      dispatch({ type:actions.SET_ACTIVE, value });
    },
    setQuery: value => {
      dispatch({ type:actions.SET_QUERY, value });
    },
    setSearching: value => {
      dispatch({ type:actions.SET_SEARCHING, value });
    },
    search: value => {
      if (value === 0) {
        // Reset active page to first item
        dispatch({ type:actions.SET_ACTIVE, value: 1 });
      }

      state.query.from = value;
      dispatch({ type:actions.SET_SEARCHING, value: true });
      SearchAPI(state.query).then(res => {
        if (res && res.status === 200) {
          let total = res.data.hits.total.value;
          let results = res.data.hits.hits;
          let response = res.data;
          dispatch({ type:actions.SET_TOTAL, value: total });
          dispatch({ type:actions.SET_RESULTS, value: results });
          dispatch({ type:actions.SET_RESPONSE, value: response });
        }
        dispatch({ type:actions.SET_SEARCHING, value: false });
      }, (error) => {
        console.log(error);
        dispatch({ type:actions.SET_SEARCHING, value: false });
      });
    },
    reset: () => {
      dispatch({ type: actions.RESET });
    }
  }

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  )
};

export { Provider, SearchContext };